import { EuiBadge, EuiCallOut } from '@elastic/eui';
import React, { useMemo } from 'react';
import { CreateFecha } from '../../../../../shared/utils/fecha';
import { useStateApp } from '../../../context/StateAppContext';
import './styles.css';

const dataPanel = {
    lock:{
        iconType: `lock`,
        title: <p>{`La aplicación está bloqueada por el administrador. `}<strong>{`Solamente se pueden adjuntar archivos.`}</strong></p>,
        color: `danger`,
        colorCompress: `#f8e9e9`,
        textColor: `#bd271e`
    },
    partialLock:{
        title: ``,
        iconType: `alert`,
        color: `warning`,
        colorCompress: `#fef6e6`,
        textColor: `#936400`
    }
}

const dataPanelValidacion = {
    lock:{
        iconType: `lock`,
        title: <p>{`La aplicación está bloqueada por el administrador. `}<strong>{`Solamente se pueden adjuntar archivos y validar partes.`}</strong></p>,
        color: `danger`,
        colorCompress: `#f8e9e9`,
        textColor: `#bd271e`
    },
    partialLock:{
        title: ``,
        iconType: `alert`,
        color: `warning`,
        colorCompress: `#fef6e6`,
        textColor: `#936400`
    }
}


export const PanelInfoBloqueoApp = (props) =>{
    const {currentSettingsApp} = useStateApp();
    const {validacion, withClass, compress} = props;


    const data = useMemo(()=> {
        const tipoDatos = (validacion!==undefined || validacion===true) ? dataPanelValidacion : dataPanel;

        return (
        currentSettingsApp && (currentSettingsApp.bloqueado === true ? tipoDatos.lock 
            : (currentSettingsApp.bloqueado === null ? tipoDatos.partialLock : undefined)))
    },[currentSettingsApp, validacion])

    const title = useMemo(()=>{
        let text = data && data.title || '';
        if(currentSettingsApp && (currentSettingsApp.bloqueado === null))
        {
            const dateDesde =  CreateFecha(currentSettingsApp.fechaBloqueoParcialDesde)
            const dateHasta =  CreateFecha(currentSettingsApp.fechaBloqueoParcialHasta)

            const textPartes = <p>{`${text}`}<strong>{`Bloqueada la creación y edición de los partes hasta el ${dateHasta}. `}</strong> {`Solamente se pueden adjuntar archivos.`}</p>
            const textValidacion = <p>{`${text}`}<strong>{`Bloqueada la edición y desvalidación de los partes hasta el ${dateHasta}. `}</strong> {`Solamente se pueden adjuntar archivos y validar partes.`}</p>
            text = (validacion!==undefined || validacion===true) ? textValidacion : textPartes;
        }

        return text
    },[currentSettingsApp, validacion])

    const renderCustomClass = useMemo(()=> (withClass===true || withClass=== undefined),[withClass])

    return (
        data!==undefined?
           !compress ? <EuiCallOut
            size="s"
            className={ renderCustomClass ?'callOutInfoBloqueoApp':''}
            title={title}
            iconType={data.iconType}
            color={data.color}
            >
                {renderCustomClass?<p>{data.text}</p>:data.text}
            </EuiCallOut>
            :
            <EuiBadge style={{color:data.textColor}} color={data.colorCompress} iconType={data.iconType} iconSide="left">{title}</EuiBadge>
        :null
    )
}